import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset scroll ke atas saat ganti route.
 * SPA tidak reload dokumen, jadi posisi scroll container ikut terbawa.
 */
const ScrollToTop = ({ containerRef }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        const el = containerRef?.current;
        if (el) {
            el.scrollTop = 0;
            el.scrollLeft = 0;
        }
    }, [pathname, containerRef]);

    return null;
};

export default ScrollToTop;
